import type { ReactNode } from 'react';

export const symbol_match_case_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M184-260q-13 0-20-10t-2-22l109-299L78-784q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l707 706q9 9 8.5 21.5T827-77q-9 9-21 9t-21-9L482-380l32 88q5 12-2.5 22T491-260q-8 0-14.5-4t-8.5-12l-37-105H244l-37 105q-2 7-8.5 11.5T184-260Zm122-296-46 131h155l-12-34-97-97Zm418 247q18-14 30-36t12-49q-16-8-38-13t-43-5q-16 0-29 3t-24 8l-31-31q16-9 35-13.5t42-4.5q26 0 48.5 4.5T765-433v-18q0-38-20.5-58.5T685-530q-18 0-34.5 5T620-509q-7 5-15 4t-14-7q-6-6-6.5-14.5T591-540q20-16 42.5-23t51.5-7q62 0 93.5 31t31.5 93v187q0 10-9.5 13.5T784-249l-60-60Z"
		/>
	</svg>
);
